/**
 * Global state that keeps track of whether the scroll should be locked.
 */
export const lockScroll = $state({ lock: false });
